import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, contracterActions } from '../../store/actions'
import Input from '../input'
import moment from 'moment'
import { commons } from '../../hook/common'
import Calendar from '../component-box/Calendar'

/**
 * 수출근거서류 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopupAddFiles = (props) => {
  const nodeBaseInfo = {
    fileCd: {
      title: '근거서류코드',
      length: 10,
    },
    fileNo: {
      title: '근거서류번호',
      type: 'text',
      length: 11,
      required: true,
      message: '근거서류번호를 입력해주세요.',
    },
    hsCd: {
      title: 'HS부호',
      type: 'text',
      length: 10,
      required: true,
      message: 'HS부호를 입력해주세요.',
    },
    itemnm: {
      title: '품명',
      type: 'text',
      length: 200,
    },
    itemdeftxt: {
      title: '규격',
      type: 'text',
      length: 200,
    },
    totamtcur: {
      title: '총금액통화코드',
      type: 'select',
      length: 10,
      readOnly: true,
    },
    amt: {
      title: '금액',
      type: 'number',
      required: true,
      message: '총금액을 입력해주세요.',
    },
    stngYmd: {
      title: '선적기일',
    },
    issueType: {
      title: '기관코드',
      type: 'text',
      readOnly: true,
    },
    issueCd: {
      title: '기관종류',
      type: 'text',
      readOnly: true,
    },
  }

  const fileType = [
    { title: '수출신고필증', value: '811' },
    { title: '외화표시 수출계약서', value: '465' },
  ]

  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [state, setState] = useState({})
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const [reset, setReset] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editIdx, setEditIdx] = useState(-1)
  const [itemList, setItemList] = useState(props.stepData)
  const [itemInput, setItemInput] = useState({ fileCd: '811' })
  const [selectItems, setSelectItems] = useState([])

  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step3

    setItemList(list)
    commons.preventKeyDown()
  }, [])

  /**
   * 데이터 저장 후 입력폼 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setItemList(props?.stepData)
      newInput()
      setReset(true)
    }
    props.setCalled(false)
  }, [props?.isCalled])

  /**
   * input 갱신을 위한 hook
   */
  useEffect(() => {
    if (reset === true) setReset(false)
  }, [reset])

  /**
   * 물품목록 선택팝업 콜백
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2
    let item = list?.filter((item) => {
      return item.crtItemSeq === props.selectItemSeq
    })[0]

    item &&
      setItemInput({
        ...itemInput,
        hsCd: item?.hsCd,
        itemnm: item?.itemnm,
        itemdeftxt: item?.itemdeftxt,
      })
  }, [props.selectItemSeq])

  /**
   * 입력학목 유효성 체크 및 저장 api 호출
   */
  const saveItem = () => {
    setState({ ...state, submitted: !state.submitted, errCrtYmd: '' })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index].focus()
      }
    })

    if (!itemInput.stngYmd || itemInput.stngYmd?.length <= 0) {
      setState({ ...state, errStngYmd: '선적기일을 선택해주세요.' })
      errCnt++
    }

    if (errCnt > 0) return
    ;(!itemInput.fileCd || itemInput.fileCd?.length <= 0) && (itemInput.fileCd = '811')
    itemInput.issueType = 'KTNET'
    itemInput.issueCd = 'KTNET'

    props.saveStep(props.docid, '3', itemInput, isEdit)
  }

  /**
   * 물품정보 수정
   * @param seq
   */
  const selectEdit = (crtFileSeq, index = -1) => {
    if (editIdx === index) {
      newInput()
    } else {
      setItemInput({ ...itemList[itemList.findIndex((item) => item.crtFileSeq === crtFileSeq)] })
      setIsEdit(true)
      setEditIdx(index)
    }
  }

  /**
   * 새로작성
   */
  const newInput = () => {
    setState({ ...state, errStngYmd: '' })
    let node = nodeInfo
    Object.keys(node).forEach((key, index) => {
      node[key].errMessage = null
    })

    setSelectItems([])
    setItemInput({})
    setIsEdit(false)
    setEditIdx(-1)
    setReset(true)
  }

  /**
   * 선택삭제
   * @returns {*}
   */
  const deleteItems = () => {
    if (selectItems?.length <= 0) {
      return props.error({ message: '삭제할 물품을 선택해주세요.' })
    }

    props.confirm({
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteStepItems(props.docid, '3', selectItems)
        },
      },
    })
  }

  /**
   * 전체삭제
   */
  const deleteAll = () => {
    itemList?.length > 0 &&
      props.confirm({
        title: '확인',
        message: '정말 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteStepItemAll(props.docid, '3')
          },
        },
      })
  }

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setItemInput({
      ...itemInput,
      [name]: value,
    })
  }

  const onSelectItem = (e) => {
    const { name, checked } = e.target
    let list = selectItems
    if (checked) {
      list.push(name)
    } else {
      list = selectItems.filter((item) => item !== name)
    }
    setSelectItems(list)
  }

  const generateInput = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = 'form-control input-text '
    let wrapperClassName = node?.wrapperClassName
    let maxLength = node.length
    !maxLength && node?.type === 'number' && (maxLength = 16)
    node?.readOnly === true && (className += 'disabled ')

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        value={itemInput?.[key] || ''}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={maxLength}
        errMessage={node.errMessage}
      />
    )
  }

  return (
    <React.Fragment>
      <div className="modal-overlay normal modal-certificate">
        <div className="modal modal-Full">
          <div className="modal-content">
            <div className="modal-header flex-sb">
              <div className="modal-title dis-flex">수출근거서류 정보</div>

              <button type="button" className="icon-close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="lineBox">
                <ul className="step-detail">
                  <li className="flex-l m-b-10">
                    <h4 className="title">근거서류명</h4>
                    <div className="select-wrap">
                      <select title="근거서류명" id="fileCd" name="fileCd" onChange={handleChange}>
                        {fileType.map((type, index) => {
                          return (
                            <option key={'cd' + index} value={type.value}>
                              {type.title}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      근거서류번호 <span className="required">*</span>
                    </h4>
                    {generateInput('fileNo')}
                  </li>
                  <li className="m-b-10">
                    <div className="flex-l">
                      <h4 className="title">구매물품 목록 선택</h4>
                      <button className="btn btn-blue" onClick={() => props.isShowItems(true)}>
                        선택
                      </button>
                    </div>
                    <p className="des">("구매물품 목록" 에서 입력한 제품을 선택)</p>
                  </li>
                  <li className=" m-b-10">
                    <div className="flex-l">
                      <h4 className="title">
                        HS부호 <span className="required">*</span>
                      </h4>
                      {generateInput('hsCd')}
                    </div>
                    <p className="des">근거서류당 1개의 대표 HS부호만 등록하시면 됩니다.</p>
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">품명</h4>
                    {generateInput('itemnm')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">규격</h4>
                    {generateInput('itemdeftxt')}
                  </li>
                  <li className="flex-l m-b-10 type-sel-form">
                    <h4 className="title">
                      총 금액 <span className="required">*</span>
                    </h4>
                    <div className="select-wrap W-10 ">
                      <select
                        id="totamtcur"
                        title={'통화코드'}
                        name="totamtcur"
                        value={itemInput.totamtcur || ''}
                        onChange={handleChange}
                      >
                        <option value="">통화코드</option>
                        <option value="USD">USD</option>
                        <option value="KRW">KRW</option>
                      </select>
                    </div>
                    {generateInput('amt')}
                  </li>
                  <li className="flex-l">
                    <h4 className="title">
                      선적기일 <span className="required">*</span>
                    </h4>
                    <div className="input-wrapper ">
                      {reset === false && (
                        <Calendar
                          default={itemInput.stngYmd && moment(itemInput.stngYmd, 'YYYYMMDD').format('YYYY-MM-DD')}
                          onSelect={(value) =>
                            setItemInput({
                              ...itemInput,
                              stngYmd: moment(value).format('YYYYMMDD'),
                            })
                          }
                        />
                      )}
                      {state.errStngYmd && <div className={'input-error'}>{state.errStngYmd}</div>}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="title-btn m-t-20">
                <div className="dis-flex ">
                  <span className="totalPage w-50">총 {itemList?.length}건</span>
                  <div className="flex-r w-50">
                    <button className="btn btn-white" onClick={newInput}>
                      새로작성
                    </button>
                    <button className="btn btn-white" onClick={saveItem}>
                      {isEdit === true ? '수정' : '저장'}
                    </button>
                    <button className="btn btn-white" onClick={deleteItems}>
                      선택삭제
                    </button>
                    <button className="btn btn-white" onClick={deleteAll}>
                      전체삭제
                    </button>
                  </div>
                </div>
              </div>
              <div className="table">
                <div className="row header border">
                  <div className="cell w-7">선택</div>
                  <div className="cell w-10">근거서류명 및 번호</div>
                  <div className="cell ">HS부호</div>
                  <div className="cell w-10">품명</div>
                  <div className="cell w-10">규격</div>
                  <div className="cell w-10">금액</div>
                  <div className="cell w-7">선적기일</div>
                </div>
                {itemList?.length > 0 ? (
                  itemList?.map((item, index) => {
                    return (
                      <div className={'row ' + (isEdit && editIdx === index ? 'active' : '')} key={index}>
                        <div className="cell">
                          <input type="checkbox" title={'checkbox' + index} name={item.crtFileSeq} onChange={onSelectItem} />
                        </div>
                        <div
                          className="cell"
                          data-title={'근거서류명 및 번호'}
                          onClick={() => selectEdit(item.crtFileSeq, index)}
                        >
                          {
                            fileType.find((file) => {
                              return file.value === item.fileCd
                            })?.title
                          }
                          <br />[{item.fileNo}]
                        </div>
                        <div className="cell" data-title={'HS부호'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {item.hsCd}
                        </div>
                        <div className="cell" data-title={'품명'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {item.itemnm}
                        </div>
                        <div className="cell" data-title={'규격'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {item.itemdeftxt}
                        </div>
                        <div className="cell" data-title={'금액'}>
                          {item.totamtcur} {commons.addComma(item.amt)}
                        </div>
                        <div className="cell" data-title={'선적기일'}>
                          {moment(item.stngYmd).format('Y-M-D')}
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="row noData">
                    <div className="cell">등록된 자료가 없습니다.</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.contracter?.data?.step3,
    isCalled: state.contracter.isCalled,
    selectItemSeq: state.contracter.itemSeq,
  }
}

const actionCreators = {
  saveStep: contracterActions.saveStep,
  setCalled: contracterActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteStepItems: contracterActions.deleteStepItems,
  deleteStepItemAll: contracterActions.deleteStepItemAll,
  isShowItems: contracterActions.isShowItems,
}

export default connect(mapStateToProps, actionCreators)(PopupAddFiles)
